
var state = {
     xiaoqulist:[],//校区列表
	 xueduanlist:[{title:'小学',id:1},{title:'初中',id:2},{title:'高中',id:3}],//学段列表
	 xueduanlistset:[{title:'小学',id:1},{title:'初中',id:2},{title:'高中',id:3}],
	 skactive:'list',//授课模块  list 列表   recycle 回收站  folder
	 skactivehref:'',//上一个跳转
	 skactivename:'',//名称
	 getradioslist:[],//年级信息
	 showflag:false,//教学资源
	 moreflag:false,//更过功能
   xueduanlist:[],//学段列表
   subjectlist:[],//科目列表
   zujuanshowflag: false, //组卷
}
export default state



// WEBPACK FOOTER //
// ./src/store/modules/setting/state.js